import { pickBy } from 'lodash'
import { createSelector } from 'reselect'

import { generateKey } from '../../utils/functions'

/**
 * Direct selector to the app state domain
 */
export const selectSdManagerDomain = () => (state) => state.sdManager
export const selectKeywordsSD = () =>
  createSelector(selectSdManagerDomain(), (substate) => substate.keywords)

export const selectSDForKeywordIdeas = () =>
  createSelector(
    selectSdManagerDomain(),
    (_, props) => ({
      lang: props.lang,
      locId: props.locId,
      keywordsData: props.keywordsData || [],
    }),
    (subState, { lang, locId, keywordsData }) => {
      return pickBy(subState.keywords, (value, key) =>
        keywordsData.some(
          (item) => key === generateKey([lang, locId, item.keyword]),
        ),
      )
    },
  )

export const selectSDForKeywordsList = () =>
  createSelector(
    selectSdManagerDomain(),
    (_, props) => ({
      keywordsData: props.keywordsData || [],
    }),
    (subState, { keywordsData }) => {
      return pickBy(subState.keywords, (value, key) =>
        keywordsData.some(
          (item) =>
            key === generateKey([item.language, item.loc_id, item.keyword]),
        ),
      )
    },
  )

export const selectSDForKeyword = () =>
  createSelector(
    selectSdManagerDomain(),
    (_, props) => ({
      lang: props.lang,
      locId: props.locId,
      keyword: props.keyword,
    }),
    (subState, { lang, locId, keyword }) =>
      subState.keywords[generateKey([lang, locId, keyword])],
  )

export const selectMetric = () =>
  createSelector(selectSdManagerDomain(), (substate) => substate.metric)

export const selectIsPolling = () =>
  createSelector(selectSdManagerDomain(), (substate) => substate.isPolling)

export const selectKeywordMetricsLimits = () =>
  createSelector(selectSdManagerDomain(), (substate) => {
    return substate.metricsLimits
  })
export const selectIsFailed = () =>
  createSelector(selectSdManagerDomain(), (substate) => substate.isFailed)
